export const SHARED_JOURNEY_UI_FALLBACKS = Object.freeze({
  pl: {
    'ui.draftDemo': 'Wersja demonstracyjna — niezatwierdzona przez Trust',
    'ui.urgentMaternity.title': 'Potrzebujesz pilnej porady położniczej?',
    'ui.urgentMaternity.body': 'Skorzystaj z aktualnych informacji Trustu dotyczących triage położniczego, aby dowiedzieć się, z kim i kiedy się skontaktować.',
    'ui.questions.added': 'Dodano',
    'ui.questions.add': 'Dodaj do „Mojej opieki”',
    'ui.important': 'Ważne:',
    'ui.stage.peopleTitle': 'Osoby zaangażowane na tym etapie',
    'ui.stage.peopleDescription': 'To niektóre osoby, które możesz spotkać na tym etapie opieki.',
    'ui.people.roleInstruction': "Wybierz jedną z ról w zespole opieki, aby dowiedzieć się, czym zajmuje się ta osoba i jak może Ci pomóc podczas opieki.",
    'ui.stage.peopleShowMore': 'Pokaż więcej osób',
    'ui.stage.peopleShowFewer': 'Pokaż mniej osób',
    'ui.stage.checkpoint.title': 'Zanim przejdziesz dalej',
    'ui.stage.checkpoint.intro': 'Krótka chwila, by sprawdzić, czy wiesz, czego możesz się spodziewać.',
    'ui.stage.checkpoint.understandNext': 'Czy rozumiem, co może wydarzyć się dalej?',
    'ui.stage.checkpoint.contact': 'Czy wiem, z kim skontaktować się w razie pytań lub obaw?',
    'ui.stage.checkpoint.askTeam': 'Czy jest coś, o co chcę zapytać mój zespół opieki?',
    'ui.completion.reviewMyCare': 'Przejrzyj „Moją opiekę”',
    'ui.completion.returnTop': 'Wróć na górę',
    'ui.completion.preparednessQuestion': 'Czy po przejrzeniu tego przewodnika czujesz się lepiej przygotowany(-a) do wizyty?',
    'ui.completion.preparednessHint': 'Wybierz jedną odpowiedź. Twoja odpowiedź jest anonimowa.',
    'ui.completion.thankYou': 'Dziękujemy za opinię',
    'ui.completion.recorded': 'Twoja odpowiedź została zapisana.',
    'ui.completion.feedbackAria': 'Ocena przygotowania do wizyty',
    'ui.completion.responses.definitely': 'Tak, zdecydowanie',
    'ui.completion.responses.a_little': 'Tak, trochę',
    'ui.completion.responses.no_change': 'Bez zmian',
    'ui.completion.responses.not_really': 'Raczej nie',
  },
  ro: {
    'ui.draftDemo': 'Demonstrație preliminară — neaprobată de Trust',
    'ui.urgentMaternity.title': 'Aveți nevoie de sfaturi urgente de maternitate?',
    'ui.urgentMaternity.body': 'Folosiți informațiile actuale ale Trustului despre triajul de maternitate pentru a afla pe cine și când să contactați.',
    'ui.questions.added': 'Adăugat',
    'ui.questions.add': 'Adăugați în Îngrijirea mea',
    'ui.important': 'Important:',
    'ui.stage.peopleTitle': 'Persoanele implicate în această etapă',
    'ui.stage.peopleDescription': 'Acestea sunt câteva dintre persoanele pe care le puteți întâlni în această etapă a îngrijirii.',
    'ui.people.roleInstruction': "Selectați un rol pentru a afla ce face această persoană și cum vă poate ajuta pe parcursul îngrijirii dumneavoastră.",
    'ui.stage.peopleShowMore': 'Arată mai multe persoane',
    'ui.stage.peopleShowFewer': 'Arată mai puține persoane',
    'ui.stage.checkpoint.title': 'Înainte de a continua',
    'ui.stage.checkpoint.intro': 'Un moment scurt pentru a verifica dacă știți la ce să vă așteptați.',
    'ui.stage.checkpoint.understandNext': 'Înțeleg ce s-ar putea întâmpla în continuare?',
    'ui.stage.checkpoint.contact': 'Știu pe cine să contactez dacă am întrebări sau îngrijorări?',
    'ui.stage.checkpoint.askTeam': 'Este ceva ce vreau să întreb echipa mea de îngrijire?',
    'ui.completion.reviewMyCare': 'Revizuiți Îngrijirea mea',
    'ui.completion.returnTop': 'Înapoi sus',
    'ui.completion.preparednessQuestion': 'Vă simțiți mai pregătit(ă) pentru vizită după parcurgerea acestui ghid?',
    'ui.completion.preparednessHint': 'Alegeți un singur răspuns. Răspunsul este anonim.',
    'ui.completion.thankYou': 'Vă mulțumim pentru feedback',
    'ui.completion.recorded': 'Răspunsul dumneavoastră a fost înregistrat.',
    'ui.completion.feedbackAria': 'Feedback privind gradul de pregătire',
    'ui.completion.responses.definitely': 'Da, cu siguranță',
    'ui.completion.responses.a_little': 'Da, puțin',
    'ui.completion.responses.no_change': 'Nicio schimbare',
    'ui.completion.responses.not_really': 'Nu prea',
  },
  fr: {
    'ui.draftDemo': 'Démonstration provisoire — non approuvée par l’établissement',
    'ui.urgentMaternity.title': 'Besoin d’un conseil urgent de maternité ?',
    'ui.urgentMaternity.body': 'Consultez les informations actuelles de l’établissement sur le triage maternité pour savoir qui contacter et quand.',
    'ui.questions.added': 'Ajouté',
    'ui.questions.add': 'Ajouter à Mes soins',
    'ui.important': 'Important :',
    'ui.stage.peopleTitle': 'Professionnels impliqués à cette étape',
    'ui.stage.peopleDescription': 'Voici quelques professionnels que vous pouvez rencontrer à cette étape de vos soins.',
    'ui.people.roleInstruction': "Sélectionnez un rôle pour découvrir ce que fait cette personne et comment elle peut vous aider pendant votre prise en charge.",
    'ui.stage.peopleShowMore': 'Afficher plus de personnes',
    'ui.stage.peopleShowFewer': 'Afficher moins de personnes',
    'ui.stage.checkpoint.title': 'Avant de continuer',
    'ui.stage.checkpoint.intro': 'Un bref moment pour vérifier que vous savez à quoi vous attendre.',
    'ui.stage.checkpoint.understandNext': 'Est-ce que je comprends ce qui pourrait se passer ensuite ?',
    'ui.stage.checkpoint.contact': 'Est-ce que je sais qui contacter si j’ai des questions ou des inquiétudes ?',
    'ui.stage.checkpoint.askTeam': 'Y a-t-il quelque chose que je souhaite demander à mon équipe soignante ?',
    'ui.completion.reviewMyCare': 'Consulter Mes soins',
    'ui.completion.returnTop': 'Retour en haut',
    'ui.completion.preparednessQuestion': 'Vous sentez-vous mieux préparé(e) pour votre visite après avoir consulté ce parcours ?',
    'ui.completion.preparednessHint': 'Choisissez une réponse. Votre réponse est anonyme.',
    'ui.completion.thankYou': 'Merci pour votre avis',
    'ui.completion.recorded': 'Votre réponse a été enregistrée.',
    'ui.completion.feedbackAria': 'Évaluation de la préparation',
    'ui.completion.responses.definitely': 'Oui, tout à fait',
    'ui.completion.responses.a_little': 'Oui, un peu',
    'ui.completion.responses.no_change': 'Pas de changement',
    'ui.completion.responses.not_really': 'Pas vraiment',
  },
  es: {
    'ui.draftDemo': 'Demostración en borrador — no aprobada por el centro',
    'ui.urgentMaternity.title': '¿Necesita asesoramiento urgente de maternidad?',
    'ui.urgentMaternity.body': 'Utilice la información actual del centro sobre triaje de maternidad para saber con quién contactar y cuándo.',
    'ui.questions.added': 'Añadido',
    'ui.questions.add': 'Añadir a Mi atención',
    'ui.important': 'Importante:',
    'ui.stage.peopleTitle': 'Profesionales que pueden intervenir en esta etapa',
    'ui.stage.peopleDescription': 'Estas son algunas de las personas que puede encontrar durante esta parte de su atención.',
    'ui.people.roleInstruction': "Seleccione un miembro del equipo para saber qué hace y cómo puede ayudarle durante su atención.",
    'ui.stage.peopleShowMore': 'Mostrar más personas',
    'ui.stage.peopleShowFewer': 'Mostrar menos personas',
    'ui.stage.checkpoint.title': 'Antes de continuar',
    'ui.stage.checkpoint.intro': 'Un momento breve para comprobar que sabes qué puedes esperar.',
    'ui.stage.checkpoint.understandNext': '¿Entiendo qué podría ocurrir a continuación?',
    'ui.stage.checkpoint.contact': '¿Sé con quién contactar si tengo preguntas o inquietudes?',
    'ui.stage.checkpoint.askTeam': '¿Hay algo que quiera preguntar a mi equipo asistencial?',
    'ui.completion.reviewMyCare': 'Revisar Mi atención',
    'ui.completion.returnTop': 'Volver arriba',
    'ui.completion.preparednessQuestion': '¿Se siente mejor preparado para su visita después de completar este recorrido?',
    'ui.completion.preparednessHint': 'Elija una respuesta. Su respuesta es anónima.',
    'ui.completion.thankYou': 'Gracias por sus comentarios',
    'ui.completion.recorded': 'Su respuesta se ha registrado.',
    'ui.completion.feedbackAria': 'Valoración de preparación',
    'ui.completion.responses.definitely': 'Sí, sin duda',
    'ui.completion.responses.a_little': 'Sí, un poco',
    'ui.completion.responses.no_change': 'Sin cambios',
    'ui.completion.responses.not_really': 'No mucho',
  },
  ar: {
    'ui.draftDemo': 'نسخة تجريبية أولية — غير معتمدة من الجهة الصحية',
    'ui.urgentMaternity.title': 'هل تحتاجين إلى نصيحة عاجلة بشأن الحمل أو الولادة؟',
    'ui.urgentMaternity.body': 'استخدمي معلومات الجهة الصحية الحالية عن فرز حالات الحمل والولادة لمعرفة بمن تتصلين ومتى.',
    'ui.questions.added': 'تمت الإضافة',
    'ui.questions.add': 'أضف إلى «رعايتي»',
    'ui.important': 'مهم:',
    'ui.stage.peopleTitle': 'الأشخاص المشاركون في هذه المرحلة',
    'ui.stage.peopleDescription': 'هؤلاء بعض الأشخاص الذين قد تقابلهم خلال هذا الجزء من رعايتك.',
    'ui.people.roleInstruction': "اختر أحد أفراد فريق الرعاية لمعرفة ما يفعله وكيف يمكنه مساعدتك خلال رعايتك.",
    'ui.stage.peopleShowMore': 'عرض مزيد من الأشخاص',
    'ui.stage.peopleShowFewer': 'عرض عدد أقل من الأشخاص',
    'ui.stage.checkpoint.title': 'قبل المتابعة',
    'ui.stage.checkpoint.intro': 'لحظة قصيرة للتأكد من أنك تعرف ما يمكن توقعه.',
    'ui.stage.checkpoint.understandNext': 'هل أفهم ما الذي قد يحدث بعد ذلك؟',
    'ui.stage.checkpoint.contact': 'هل أعرف بمن أتصل إذا كانت لدي أسئلة أو مخاوف؟',
    'ui.stage.checkpoint.askTeam': 'هل هناك شيء أريد أن أسأل عنه فريق الرعاية؟',
    'ui.completion.reviewMyCare': 'راجع «رعايتي»',
    'ui.completion.returnTop': 'العودة إلى الأعلى',
    'ui.completion.preparednessQuestion': 'هل تشعر بأنك أكثر استعدادًا لزيارتك بعد إكمال هذا الدليل؟',
    'ui.completion.preparednessHint': 'اختر إجابة واحدة. إجابتك مجهولة الهوية.',
    'ui.completion.thankYou': 'شكرًا لملاحظاتك',
    'ui.completion.recorded': 'تم تسجيل إجابتك.',
    'ui.completion.feedbackAria': 'تقييم الاستعداد للزيارة',
    'ui.completion.responses.definitely': 'نعم، بالتأكيد',
    'ui.completion.responses.a_little': 'نعم، قليلًا',
    'ui.completion.responses.no_change': 'لا تغيير',
    'ui.completion.responses.not_really': 'ليس كثيرًا',
  },
  ur: {
    'ui.draftDemo': 'ابتدائی نمائشی ورژن — Trust سے منظور شدہ نہیں',
    'ui.urgentMaternity.title': 'کیا آپ کو فوری زچگی مشورے کی ضرورت ہے؟',
    'ui.urgentMaternity.body': 'کس سے اور کب رابطہ کرنا ہے، یہ جاننے کے لیے Trust کی موجودہ زچگی ٹرائیج معلومات استعمال کریں۔',
    'ui.questions.added': 'شامل کر دیا گیا',
    'ui.questions.add': 'میری نگہداشت میں شامل کریں',
    'ui.important': 'اہم:',
    'ui.stage.peopleTitle': 'اس مرحلے میں شامل افراد',
    'ui.stage.peopleDescription': 'یہ کچھ لوگ ہیں جن سے آپ نگہداشت کے اس حصے کے دوران مل سکتے ہیں۔',
    'ui.people.roleInstruction': "نگہداشت کی ٹیم کے کسی رکن کو منتخب کریں تاکہ جان سکیں کہ وہ کیا کام کرتا ہے اور آپ کی نگہداشت میں کیسے مدد کر سکتا ہے۔",
    'ui.stage.peopleShowMore': 'مزید لوگ دکھائیں',
    'ui.stage.peopleShowFewer': 'کم لوگ دکھائیں',
    'ui.stage.checkpoint.title': 'آگے بڑھنے سے پہلے',
    'ui.stage.checkpoint.intro': 'ایک مختصر لمحہ یہ جانچنے کے لیے کہ آپ جانتے ہیں آگے کیا توقع کی جا سکتی ہے۔',
    'ui.stage.checkpoint.understandNext': 'کیا میں سمجھتا/سمجھتی ہوں کہ آگے کیا ہو سکتا ہے؟',
    'ui.stage.checkpoint.contact': 'کیا مجھے معلوم ہے کہ سوال یا تشویش کی صورت میں کس سے رابطہ کرنا ہے؟',
    'ui.stage.checkpoint.askTeam': 'کیا میں اپنی نگہداشت کی ٹیم سے کچھ پوچھنا چاہتا/چاہتی ہوں؟',
    'ui.completion.reviewMyCare': 'میری نگہداشت دیکھیں',
    'ui.completion.returnTop': 'اوپر واپس جائیں',
    'ui.completion.preparednessQuestion': 'کیا اس رہنما کو مکمل کرنے کے بعد آپ اپنی ملاقات کے لیے زیادہ تیار محسوس کرتے ہیں؟',
    'ui.completion.preparednessHint': 'ایک جواب منتخب کریں۔ آپ کا جواب گمنام ہے۔',
    'ui.completion.thankYou': 'آپ کی رائے کا شکریہ',
    'ui.completion.recorded': 'آپ کا جواب ریکارڈ کر لیا گیا ہے۔',
    'ui.completion.feedbackAria': 'تیاری سے متعلق رائے',
    'ui.completion.responses.definitely': 'جی ہاں، بالکل',
    'ui.completion.responses.a_little': 'جی ہاں، تھوڑا',
    'ui.completion.responses.no_change': 'کوئی تبدیلی نہیں',
    'ui.completion.responses.not_really': 'زیادہ نہیں',
  },
  bn: {
    'ui.draftDemo': 'খসড়া প্রদর্শনী — ট্রাস্ট অনুমোদিত নয়',
    'ui.urgentMaternity.title': 'জরুরি মাতৃত্ব পরামর্শ দরকার?',
    'ui.urgentMaternity.body': 'কাকে এবং কখন যোগাযোগ করবেন তা জানতে ট্রাস্টের বর্তমান মাতৃত্ব ট্রায়াজ তথ্য ব্যবহার করুন।',
    'ui.questions.added': 'যোগ করা হয়েছে',
    'ui.questions.add': 'আমার যত্নে যোগ করুন',
    'ui.important': 'গুরুত্বপূর্ণ:',
    'ui.stage.peopleTitle': 'এই পর্যায়ে জড়িত ব্যক্তিরা',
    'ui.stage.peopleDescription': 'এই পর্যায়ের যত্নে আপনি যাদের সঙ্গে দেখা করতে পারেন, এরা তাদের কয়েকজন।',
    'ui.people.roleInstruction': "এই ব্যক্তি কী কাজ করেন এবং আপনার যত্নে কীভাবে সাহায্য করতে পারেন তা জানতে একটি ভূমিকা নির্বাচন করুন।",
    'ui.stage.peopleShowMore': 'আরও মানুষ দেখুন',
    'ui.stage.peopleShowFewer': 'কম মানুষ দেখুন',
    'ui.stage.checkpoint.title': 'এগিয়ে যাওয়ার আগে',
    'ui.stage.checkpoint.intro': 'পরবর্তী কী হতে পারে তা আপনি বুঝেছেন কি না, তা যাচাই করার জন্য একটি ছোট মুহূর্ত।',
    'ui.stage.checkpoint.understandNext': 'এরপর কী হতে পারে তা কি আমি বুঝি?',
    'ui.stage.checkpoint.contact': 'আমার প্রশ্ন বা উদ্বেগ থাকলে কাকে যোগাযোগ করতে হবে তা কি আমি জানি?',
    'ui.stage.checkpoint.askTeam': 'আমার যত্ন দলের কাছে কি কিছু জিজ্ঞেস করতে চাই?',
    'ui.completion.reviewMyCare': 'আমার যত্ন পর্যালোচনা করুন',
    'ui.completion.returnTop': 'উপরে ফিরে যান',
    'ui.completion.preparednessQuestion': 'এই নির্দেশিকা শেষ করার পর আপনি কি আপনার ভিজিটের জন্য আরও প্রস্তুত মনে করছেন?',
    'ui.completion.preparednessHint': 'একটি উত্তর বেছে নিন। আপনার উত্তর বেনামী।',
    'ui.completion.thankYou': 'আপনার মতামতের জন্য ধন্যবাদ',
    'ui.completion.recorded': 'আপনার উত্তর রেকর্ড করা হয়েছে।',
    'ui.completion.feedbackAria': 'প্রস্তুতি সম্পর্কিত মতামত',
    'ui.completion.responses.definitely': 'হ্যাঁ, অবশ্যই',
    'ui.completion.responses.a_little': 'হ্যাঁ, কিছুটা',
    'ui.completion.responses.no_change': 'কোনো পরিবর্তন নেই',
    'ui.completion.responses.not_really': 'তেমন নয়',
  },
  pa: {
    'ui.draftDemo': 'ਡਰਾਫਟ ਡੈਮੋ — Trust ਵੱਲੋਂ ਮਨਜ਼ੂਰ ਨਹੀਂ',
    'ui.urgentMaternity.title': 'ਤੁਰੰਤ ਮਾਤਰਤਾ ਸਲਾਹ ਦੀ ਲੋੜ ਹੈ?',
    'ui.urgentMaternity.body': 'ਕਿਸ ਨਾਲ ਅਤੇ ਕਦੋਂ ਸੰਪਰਕ ਕਰਨਾ ਹੈ, ਇਹ ਜਾਣਨ ਲਈ Trust ਦੀ ਮੌਜੂਦਾ ਮਾਤਰਤਾ ਟ੍ਰਾਇਆਜ ਜਾਣਕਾਰੀ ਵਰਤੋ।',
    'ui.questions.added': 'ਸ਼ਾਮਲ ਕੀਤਾ',
    'ui.questions.add': 'ਮੇਰੀ ਦੇਖਭਾਲ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ',
    'ui.important': 'ਮਹੱਤਵਪੂਰਨ:',
    'ui.stage.peopleTitle': 'ਇਸ ਪੜਾਅ ਵਿੱਚ ਸ਼ਾਮਲ ਲੋਕ',
    'ui.stage.peopleDescription': 'ਇਹ ਉਹਨਾਂ ਲੋਕਾਂ ਵਿੱਚੋਂ ਕੁਝ ਹਨ ਜਿਨ੍ਹਾਂ ਨੂੰ ਤੁਸੀਂ ਆਪਣੀ ਦੇਖਭਾਲ ਦੇ ਇਸ ਹਿੱਸੇ ਦੌਰਾਨ ਮਿਲ ਸਕਦੇ ਹੋ।',
    'ui.people.roleInstruction': "ਇਹ ਵਿਅਕਤੀ ਕੀ ਕਰਦਾ ਹੈ ਅਤੇ ਤੁਹਾਡੀ ਦੇਖਭਾਲ ਵਿੱਚ ਕਿਵੇਂ ਮਦਦ ਕਰ ਸਕਦਾ ਹੈ, ਇਹ ਜਾਣਨ ਲਈ ਇੱਕ ਭੂਮਿਕਾ ਚੁਣੋ।",
    'ui.stage.peopleShowMore': 'ਹੋਰ ਲੋਕ ਦਿਖਾਓ',
    'ui.stage.peopleShowFewer': 'ਘੱਟ ਲੋਕ ਦਿਖਾਓ',
    'ui.stage.checkpoint.title': 'ਅੱਗੇ ਵਧਣ ਤੋਂ ਪਹਿਲਾਂ',
    'ui.stage.checkpoint.intro': 'ਇੱਕ ਛੋਟਾ ਜਿਹਾ ਪਲ ਇਹ ਵੇਖਣ ਲਈ ਕਿ ਤੁਹਾਨੂੰ ਪਤਾ ਹੈ ਅੱਗੇ ਕੀ ਉਮੀਦ ਕਰਨੀ ਹੈ।',
    'ui.stage.checkpoint.understandNext': 'ਕੀ ਮੈਂ ਸਮਝਦਾ/ਸਮਝਦੀ ਹਾਂ ਕਿ ਅੱਗੇ ਕੀ ਹੋ ਸਕਦਾ ਹੈ?',
    'ui.stage.checkpoint.contact': 'ਜੇ ਮੇਰੇ ਕੋਈ ਸਵਾਲ ਜਾਂ ਚਿੰਤਾਵਾਂ ਹਨ ਤਾਂ ਕੀ ਮੈਨੂੰ ਪਤਾ ਹੈ ਕਿ ਕਿਸ ਨਾਲ ਸੰਪਰਕ ਕਰਨਾ ਹੈ?',
    'ui.stage.checkpoint.askTeam': 'ਕੀ ਮੈਂ ਆਪਣੀ ਦੇਖਭਾਲ ਟੀਮ ਨੂੰ ਕੁਝ ਪੁੱਛਣਾ ਚਾਹੁੰਦਾ/ਚਾਹੁੰਦੀ ਹਾਂ?',
    'ui.completion.reviewMyCare': 'ਮੇਰੀ ਦੇਖਭਾਲ ਵੇਖੋ',
    'ui.completion.returnTop': 'ਉੱਪਰ ਵਾਪਸ ਜਾਓ',
    'ui.completion.preparednessQuestion': 'ਇਹ ਗਾਈਡ ਪੂਰੀ ਕਰਨ ਤੋਂ ਬਾਅਦ ਕੀ ਤੁਸੀਂ ਆਪਣੀ ਮੁਲਾਕਾਤ ਲਈ ਵਧੇਰੇ ਤਿਆਰ ਮਹਿਸੂਸ ਕਰਦੇ ਹੋ?',
    'ui.completion.preparednessHint': 'ਇੱਕ ਜਵਾਬ ਚੁਣੋ। ਤੁਹਾਡਾ ਜਵਾਬ ਗੁਪਤ ਹੈ।',
    'ui.completion.thankYou': 'ਤੁਹਾਡੇ ਫੀਡਬੈਕ ਲਈ ਧੰਨਵਾਦ',
    'ui.completion.recorded': 'ਤੁਹਾਡਾ ਜਵਾਬ ਦਰਜ ਹੋ ਗਿਆ ਹੈ।',
    'ui.completion.feedbackAria': 'ਤਿਆਰੀ ਬਾਰੇ ਫੀਡਬੈਕ',
    'ui.completion.responses.definitely': 'ਹਾਂ, ਬਿਲਕੁਲ',
    'ui.completion.responses.a_little': 'ਹਾਂ, ਥੋੜ੍ਹਾ',
    'ui.completion.responses.no_change': 'ਕੋਈ ਬਦਲਾਅ ਨਹੀਂ',
    'ui.completion.responses.not_really': 'ਜ਼ਿਆਦਾ ਨਹੀਂ',
  },
  so: {
    'ui.draftDemo': 'Bandhig qabyo ah — Trust ma ansixin',
    'ui.urgentMaternity.title': 'Ma u baahan tahay talo umul oo degdeg ah?',
    'ui.urgentMaternity.body': 'Isticmaal macluumaadka hadda jira ee Trust-ka ee kala-soocidda umulinta si aad u ogaato cidda iyo goorta lala xiriirayo.',
    'ui.questions.added': 'Waa lagu daray',
    'ui.questions.add': 'Ku dar Daryeelkayga',
    'ui.important': 'Muhiim:',
    'ui.stage.peopleTitle': 'Dadka ku lug leh marxaladdan',
    'ui.stage.peopleDescription': 'Kuwani waa qaar ka mid ah dadka aad la kulmi karto inta lagu jiro qaybtan daryeelkaaga.',
    'ui.people.roleInstruction': "Dooro xubin ka mid ah kooxda daryeelka si aad u ogaato waxa uu qabto iyo sida uu kaaga caawin karo daryeelkaaga.",
    'ui.stage.peopleShowMore': 'Muuji dad badan',
    'ui.stage.peopleShowFewer': 'Muuji dad yar',
    'ui.stage.checkpoint.title': 'Ka hor intaadan sii gudbin',
    'ui.stage.checkpoint.intro': 'Waqti kooban oo aad ku hubinayso inaad garanayso waxa xiga ee dhici kara.',
    'ui.stage.checkpoint.understandNext': 'Ma fahmayaa waxa laga yaabo inuu xigo?',
    'ui.stage.checkpoint.contact': 'Ma ogahay cidda aan la xiriirayo haddii aan qabo su’aalo ama walaac?',
    'ui.stage.checkpoint.askTeam': 'Ma jiraan wax aan doonayo inaan weydiiyo kooxdayda daryeelka?',
    'ui.completion.reviewMyCare': 'Dib u eeg Daryeelkayga',
    'ui.completion.returnTop': 'Ku noqo korka',
    'ui.completion.preparednessQuestion': 'Ma dareemaysaa inaad booqashadaada si fiican ugu diyaar garowday ka dib markaad dhammaysay hagahan?',
    'ui.completion.preparednessHint': 'Dooro hal jawaab. Jawaabtaadu waa qarsoodi.',
    'ui.completion.thankYou': 'Waad ku mahadsan tahay ra’yi-celintaada',
    'ui.completion.recorded': 'Jawaabtaada waa la diiwaangeliyey.',
    'ui.completion.feedbackAria': 'Ra’yi-celinta diyaar-garowga',
    'ui.completion.responses.definitely': 'Haa, hubaal',
    'ui.completion.responses.a_little': 'Haa, wax yar',
    'ui.completion.responses.no_change': 'Wax isbeddel ah ma jiro',
    'ui.completion.responses.not_really': 'Si dhab ah ma aha',
  },
  pt: {
    'ui.draftDemo': 'Demonstração preliminar — não aprovada pela instituição',
    'ui.urgentMaternity.title': 'Precisa de aconselhamento urgente de maternidade?',
    'ui.urgentMaternity.body': 'Use a informação atual da instituição sobre triagem de maternidade para saber quem contactar e quando.',
    'ui.questions.added': 'Adicionado',
    'ui.questions.add': 'Adicionar a Os meus cuidados',
    'ui.important': 'Importante:',
    'ui.stage.peopleTitle': 'Profissionais envolvidos nesta fase',
    'ui.stage.peopleDescription': 'Estas são algumas das pessoas que poderá encontrar durante esta parte dos seus cuidados.',
    'ui.people.roleInstruction': "Selecione uma função para saber mais sobre o que esta pessoa faz e como poderá ajudar nos seus cuidados.",
    'ui.stage.peopleShowMore': 'Mostrar mais pessoas',
    'ui.stage.peopleShowFewer': 'Mostrar menos pessoas',
    'ui.stage.checkpoint.title': 'Antes de continuar',
    'ui.stage.checkpoint.intro': 'Um breve momento para confirmar que sabe o que pode esperar.',
    'ui.stage.checkpoint.understandNext': 'Compreendo o que poderá acontecer a seguir?',
    'ui.stage.checkpoint.contact': 'Sei quem contactar se tiver perguntas ou preocupações?',
    'ui.stage.checkpoint.askTeam': 'Há algo que queira perguntar à minha equipa de cuidados?',
    'ui.completion.reviewMyCare': 'Rever Os meus cuidados',
    'ui.completion.returnTop': 'Voltar ao topo',
    'ui.completion.preparednessQuestion': 'Sente-se mais preparado para a sua visita depois de concluir este percurso?',
    'ui.completion.preparednessHint': 'Escolha uma resposta. A sua resposta é anónima.',
    'ui.completion.thankYou': 'Obrigado pelo seu feedback',
    'ui.completion.recorded': 'A sua resposta foi registada.',
    'ui.completion.feedbackAria': 'Feedback sobre preparação',
    'ui.completion.responses.definitely': 'Sim, sem dúvida',
    'ui.completion.responses.a_little': 'Sim, um pouco',
    'ui.completion.responses.no_change': 'Sem alteração',
    'ui.completion.responses.not_really': 'Não muito',
  },
  it: {
    'ui.draftDemo': 'Dimostrazione in bozza — non approvata dalla struttura',
    'ui.urgentMaternity.title': 'Hai bisogno di un consiglio urgente per la maternità?',
    'ui.urgentMaternity.body': 'Usa le informazioni aggiornate della struttura sul triage maternità per sapere chi contattare e quando.',
    'ui.questions.added': 'Aggiunto',
    'ui.questions.add': 'Aggiungi a La mia assistenza',
    'ui.important': 'Importante:',
    'ui.stage.peopleTitle': 'Professionisti coinvolti in questa fase',
    'ui.stage.peopleDescription': 'Queste sono alcune delle persone che potresti incontrare durante questa fase della tua assistenza.',
    'ui.people.roleInstruction': "Seleziona un ruolo per scoprire di cosa si occupa questa persona e come può aiutarti durante il tuo percorso di cura.",
    'ui.stage.peopleShowMore': 'Mostra più persone',
    'ui.stage.peopleShowFewer': 'Mostra meno persone',
    'ui.stage.checkpoint.title': 'Prima di continuare',
    'ui.stage.checkpoint.intro': 'Un breve momento per verificare di sapere cosa potrebbe succedere dopo.',
    'ui.stage.checkpoint.understandNext': 'Ho capito cosa potrebbe succedere dopo?',
    'ui.stage.checkpoint.contact': 'So chi contattare se ho domande o preoccupazioni?',
    'ui.stage.checkpoint.askTeam': 'C’è qualcosa che voglio chiedere al mio team di cura?',
    'ui.completion.reviewMyCare': 'Rivedi La mia assistenza',
    'ui.completion.returnTop': 'Torna in alto',
    'ui.completion.preparednessQuestion': 'Ti senti più preparato per la visita dopo aver completato questo percorso?',
    'ui.completion.preparednessHint': 'Scegli una risposta. La tua risposta è anonima.',
    'ui.completion.thankYou': 'Grazie per il tuo feedback',
    'ui.completion.recorded': 'La tua risposta è stata registrata.',
    'ui.completion.feedbackAria': 'Feedback sulla preparazione',
    'ui.completion.responses.definitely': 'Sì, decisamente',
    'ui.completion.responses.a_little': 'Sì, un po’',
    'ui.completion.responses.no_change': 'Nessun cambiamento',
    'ui.completion.responses.not_really': 'Non molto',
  },
  gu: {
    'ui.draftDemo': 'ડ્રાફ્ટ પ્રદર્શન — Trust દ્વારા મંજૂર નથી',
    'ui.urgentMaternity.title': 'તાત્કાલિક માતૃત્વ સલાહ જોઈએ છે?',
    'ui.urgentMaternity.body': 'કોનો અને ક્યારે સંપર્ક કરવો તે જાણવા Trustની હાલની માતૃત્વ ટ્રાયાજ માહિતીનો ઉપયોગ કરો.',
    'ui.questions.added': 'ઉમેરાયું',
    'ui.questions.add': 'મારી કાળજીમાં ઉમેરો',
    'ui.important': 'મહત્વપૂર્ણ:',
    'ui.stage.peopleTitle': 'આ તબક્કે જોડાયેલા લોકો',
    'ui.stage.peopleDescription': 'આ તમારી કાળજીના આ ભાગ દરમિયાન મળી શકે તેવા કેટલાક લોકો છે.',
    'ui.people.roleInstruction': "આ વ્યક્તિ શું કરે છે અને તમારી સંભાળમાં કેવી રીતે મદદ કરી શકે છે તે વિશે વધુ જાણવા માટે કોઈ ભૂમિકા પસંદ કરો.",
    'ui.stage.peopleShowMore': 'વધુ લોકો બતાવો',
    'ui.stage.peopleShowFewer': 'ઓછા લોકો બતાવો',
    'ui.stage.checkpoint.title': 'આગળ વધતા પહેલાં',
    'ui.stage.checkpoint.intro': 'આગળ શું થઈ શકે તે અંગે તમને સમજ છે કે નહીં તે તપાસવા માટે એક ટૂંકો વિરામ.',
    'ui.stage.checkpoint.understandNext': 'શું હું સમજું છું કે આગળ શું થઈ શકે?',
    'ui.stage.checkpoint.contact': 'જો મને પ્રશ્નો અથવા ચિંતા હોય તો કોનો સંપર્ક કરવો તે શું મને ખબર છે?',
    'ui.stage.checkpoint.askTeam': 'શું મારી કાળજી ટીમને કંઈ પૂછવું છે?',
    'ui.completion.reviewMyCare': 'મારી કાળજી જુઓ',
    'ui.completion.returnTop': 'ઉપર પાછા જાઓ',
    'ui.completion.preparednessQuestion': 'આ માર્ગદર્શિકા પૂર્ણ કર્યા પછી શું તમે તમારી મુલાકાત માટે વધુ તૈયાર અનુભવો છો?',
    'ui.completion.preparednessHint': 'એક જવાબ પસંદ કરો. તમારો જવાબ અનામી છે.',
    'ui.completion.thankYou': 'તમારા પ્રતિસાદ માટે આભાર',
    'ui.completion.recorded': 'તમારો જવાબ નોંધાયો છે.',
    'ui.completion.feedbackAria': 'તૈયારી અંગે પ્રતિસાદ',
    'ui.completion.responses.definitely': 'હા, ચોક્કસ',
    'ui.completion.responses.a_little': 'હા, થોડું',
    'ui.completion.responses.no_change': 'કોઈ ફેરફાર નથી',
    'ui.completion.responses.not_really': 'ખાસ નહીં',
  },
  tr: {
    'ui.draftDemo': 'Taslak gösterim — kurum tarafından onaylanmamıştır',
    'ui.urgentMaternity.title': 'Acil doğum ve gebelik danışmanlığına mı ihtiyacınız var?',
    'ui.urgentMaternity.body': 'Kiminle ne zaman iletişime geçeceğinizi öğrenmek için kurumun güncel doğum triyaj bilgilerini kullanın.',
    'ui.questions.added': 'Eklendi',
    'ui.questions.add': 'Bakımım’a ekle',
    'ui.important': 'Önemli:',
    'ui.stage.peopleTitle': 'Bu aşamada yer alan kişiler',
    'ui.stage.peopleDescription': 'Bunlar bakımınızın bu bölümünde karşılaşabileceğiniz kişilerden bazılarıdır.',
    'ui.people.roleInstruction': "Bu kişinin ne yaptığını ve bakımınızda size nasıl yardımcı olabileceğini öğrenmek için bir rol seçin.",
    'ui.stage.peopleShowMore': 'Daha fazla kişi göster',
    'ui.stage.peopleShowFewer': 'Daha az kişi göster',
    'ui.stage.checkpoint.title': 'Devam etmeden önce',
    'ui.stage.checkpoint.intro': 'Sonraki aşamada ne bekleyebileceğinizi bildiğinizden emin olmak için kısa bir kontrol.',
    'ui.stage.checkpoint.understandNext': 'Bundan sonra neler olabileceğini anlıyor muyum?',
    'ui.stage.checkpoint.contact': 'Sorularım veya endişelerim olursa kiminle iletişime geçeceğimi biliyor muyum?',
    'ui.stage.checkpoint.askTeam': 'Bakım ekibime sormak istediğim bir şey var mı?',
    'ui.completion.reviewMyCare': 'Bakımım’ı gözden geçir',
    'ui.completion.returnTop': 'Başa dön',
    'ui.completion.preparednessQuestion': 'Bu rehberi tamamladıktan sonra ziyaretiniz için kendinizi daha hazır hissediyor musunuz?',
    'ui.completion.preparednessHint': 'Bir yanıt seçin. Yanıtınız anonimdir.',
    'ui.completion.thankYou': 'Geri bildiriminiz için teşekkür ederiz',
    'ui.completion.recorded': 'Yanıtınız kaydedildi.',
    'ui.completion.feedbackAria': 'Hazırlık geri bildirimi',
    'ui.completion.responses.definitely': 'Evet, kesinlikle',
    'ui.completion.responses.a_little': 'Evet, biraz',
    'ui.completion.responses.no_change': 'Değişiklik yok',
    'ui.completion.responses.not_really': 'Pek değil',
  },
  fa: {
    'ui.draftDemo': 'نسخه نمایشی پیش‌نویس — مورد تأیید Trust نیست',
    'ui.urgentMaternity.title': 'به راهنمایی فوری بارداری و زایمان نیاز دارید؟',
    'ui.urgentMaternity.body': 'برای دانستن این‌که با چه کسی و چه زمانی تماس بگیرید، از اطلاعات فعلی Trust درباره تریاژ بارداری و زایمان استفاده کنید.',
    'ui.questions.added': 'اضافه شد',
    'ui.questions.add': 'افزودن به «مراقبت من»',
    'ui.important': 'مهم:',
    'ui.stage.peopleTitle': 'افراد درگیر در این مرحله',
    'ui.stage.peopleDescription': 'این‌ها برخی از افرادی هستند که ممکن است در این بخش از مراقبت خود با آن‌ها روبه‌رو شوید.',
    'ui.people.roleInstruction': "یکی از اعضای تیم مراقبت را انتخاب کنید تا بدانید چه کاری انجام می‌دهد و چگونه می‌تواند در مراقبت از شما کمک کند.",
    'ui.stage.peopleShowMore': 'افراد بیشتری نشان بده',
    'ui.stage.peopleShowFewer': 'افراد کمتری نشان بده',
    'ui.stage.checkpoint.title': 'پیش از ادامه',
    'ui.stage.checkpoint.intro': 'یک مکث کوتاه برای بررسی اینکه می‌دانید در ادامه چه چیزی ممکن است رخ دهد.',
    'ui.stage.checkpoint.understandNext': 'آیا می‌دانم ممکن است بعداً چه اتفاقی بیفتد؟',
    'ui.stage.checkpoint.contact': 'آیا می‌دانم اگر سؤال یا نگرانی داشتم با چه کسی تماس بگیرم؟',
    'ui.stage.checkpoint.askTeam': 'آیا چیزی هست که بخواهم از تیم مراقبتم بپرسم؟',
    'ui.completion.reviewMyCare': 'مرور «مراقبت من»',
    'ui.completion.returnTop': 'بازگشت به بالا',
    'ui.completion.preparednessQuestion': 'آیا پس از تکمیل این راهنما برای مراجعه خود آمادگی بیشتری احساس می‌کنید؟',
    'ui.completion.preparednessHint': 'یک پاسخ انتخاب کنید. پاسخ شما ناشناس است.',
    'ui.completion.thankYou': 'از بازخورد شما سپاسگزاریم',
    'ui.completion.recorded': 'پاسخ شما ثبت شد.',
    'ui.completion.feedbackAria': 'بازخورد درباره آمادگی',
    'ui.completion.responses.definitely': 'بله، حتماً',
    'ui.completion.responses.a_little': 'بله، کمی',
    'ui.completion.responses.no_change': 'بدون تغییر',
    'ui.completion.responses.not_really': 'نه چندان',
  },
  zh: {
    'ui.draftDemo': '草稿演示 — 尚未获医疗机构批准',
    'ui.urgentMaternity.title': '需要紧急产科建议吗？',
    'ui.urgentMaternity.body': '请使用医疗机构当前的产科分诊信息，了解应在何时联系谁。',
    'ui.questions.added': '已添加',
    'ui.questions.add': '添加到“我的护理”',
    'ui.important': '重要：',
    'ui.stage.peopleTitle': '此阶段可能参与照护的人员',
    'ui.stage.peopleDescription': '这些是您在这一阶段的护理中可能遇到的一些人员。',
    'ui.people.roleInstruction': "选择一个岗位，了解相关工作人员的职责，以及他们在您就医过程中可能提供的帮助。",
    'ui.stage.peopleShowMore': '显示更多人员',
    'ui.stage.peopleShowFewer': '显示较少人员',
    'ui.stage.checkpoint.title': '继续之前',
    'ui.stage.checkpoint.intro': '花一点时间确认您是否清楚接下来可能会发生什么。',
    'ui.stage.checkpoint.understandNext': '我是否明白接下来可能会发生什么？',
    'ui.stage.checkpoint.contact': '如果我有疑问或担忧，我是否知道该联系谁？',
    'ui.stage.checkpoint.askTeam': '我是否有想问护理团队的问题？',
    'ui.completion.reviewMyCare': '查看“我的护理”',
    'ui.completion.returnTop': '返回顶部',
    'ui.completion.preparednessQuestion': '完成本指南后，您是否觉得为此次就诊做好了更充分的准备？',
    'ui.completion.preparednessHint': '请选择一个答案。您的回答是匿名的。',
    'ui.completion.thankYou': '感谢您的反馈',
    'ui.completion.recorded': '您的回答已记录。',
    'ui.completion.feedbackAria': '就诊准备情况反馈',
    'ui.completion.responses.definitely': '是的，非常明显',
    'ui.completion.responses.a_little': '是的，有一点',
    'ui.completion.responses.no_change': '没有变化',
    'ui.completion.responses.not_really': '不太是',
  },
  tl: {
    'ui.draftDemo': 'Draft na demo — hindi aprubado ng Trust',
    'ui.urgentMaternity.title': 'Kailangan mo ba ng agarang payo sa maternity?',
    'ui.urgentMaternity.body': 'Gamitin ang kasalukuyang maternity triage information ng Trust para malaman kung sino ang kokontakin at kailan.',
    'ui.questions.added': 'Naidagdag',
    'ui.questions.add': 'Idagdag sa Aking Pangangalaga',
    'ui.important': 'Mahalaga:',
    'ui.stage.peopleTitle': 'Mga taong maaaring kasama sa yugtong ito',
    'ui.stage.peopleDescription': 'Ilan ito sa mga taong maaari mong makilala sa bahaging ito ng iyong pangangalaga.',
    'ui.people.roleInstruction': "Pumili ng isang kawani para malaman kung ano ang trabaho niya at kung paano siya maaaring makatulong sa pangangalaga sa iyo.",
    'ui.stage.peopleShowMore': 'Magpakita ng mas maraming tao',
    'ui.stage.peopleShowFewer': 'Magpakita ng mas kaunting tao',
    'ui.stage.checkpoint.title': 'Bago magpatuloy',
    'ui.stage.checkpoint.intro': 'Sandaling suriin kung malinaw sa iyo kung ano ang maaaring susunod na mangyari.',
    'ui.stage.checkpoint.understandNext': 'Nauunawaan ko ba kung ano ang maaaring mangyari sa susunod?',
    'ui.stage.checkpoint.contact': 'Alam ko ba kung sino ang kokontakin kung may tanong o alalahanin ako?',
    'ui.stage.checkpoint.askTeam': 'May gusto ba akong itanong sa aking care team?',
    'ui.completion.reviewMyCare': 'Suriin ang Aking Pangangalaga',
    'ui.completion.returnTop': 'Bumalik sa itaas',
    'ui.completion.preparednessQuestion': 'Mas handa ka ba para sa iyong pagbisita matapos makumpleto ang gabay na ito?',
    'ui.completion.preparednessHint': 'Pumili ng isang sagot. Anonymous ang iyong tugon.',
    'ui.completion.thankYou': 'Salamat sa iyong feedback',
    'ui.completion.recorded': 'Naitala ang iyong tugon.',
    'ui.completion.feedbackAria': 'Feedback tungkol sa kahandaan',
    'ui.completion.responses.definitely': 'Oo, tiyak',
    'ui.completion.responses.a_little': 'Oo, kaunti',
    'ui.completion.responses.no_change': 'Walang pagbabago',
    'ui.completion.responses.not_really': 'Hindi gaano',
  },
});

function normalizedLanguage(i18n) {
  return String(i18n?.resolvedLanguage || i18n?.language || 'en').toLowerCase().split('-')[0];
}

export function journeyUiText(i18n, t, key, englishDefault) {
  const language = normalizedLanguage(i18n);
  const direct = i18n?.getResource?.(language, 'hospitalJourney', key);
  if (typeof direct === 'string' && direct.trim()) return direct;
  const fallback = SHARED_JOURNEY_UI_FALLBACKS[language]?.[key];
  if (typeof fallback === 'string' && fallback.trim()) return fallback;
  const translated = t(key, { defaultValue: englishDefault });
  if (typeof translated === 'string' && translated.trim() && translated !== key && translated !== `hospitalJourney:${key}`) return translated;
  return englishDefault;
}
